export function isAsset(field) {
    return Boolean(field && Object.prototype.hasOwnProperty.call(field, 'assetId'));
}
//# sourceMappingURL=content-reference.js.map